import agent from "src/api/agent";




export const getAcenteAccounts = (usr) => agent.requests.get(`/Web/getaccounts`);


